import { AiFillSave } from "react-icons/ai";
import { Field, Formik } from "formik"
import { Button, Card, Col, Form, Row } from "react-bootstrap"
import * as Yup from 'yup';

function AddProveedores({agregar, initialValues}){
    const shemaValidate = Yup.object().shape({
        name:Yup.string().required('Campo Requerido'),
        priority: Yup.number().required('Campo Requerido'),
    });

    return (
        <>
            <Row>
                <Col>
                    <Formik initialValues={initialValues}
                        validationSchema={shemaValidate}
                        onSubmit={(values, { setSubmitting, setFieldValue }) => { 
                            agregar(values)     
                        }}
                    >{({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        isSubmitting,
                        setFieldValue
                    }) => (
                        <Form onSubmit={handleSubmit}  className='mt-3'>
                            <Card className="shadow-1 formSection">
                                <Card.Body>
                                    <Row>
                                        <Col xs="12" md="12">
                                            <h4><span className="subtitulo">Añadir nuevo proveedor</span></h4>
                                        </Col>
                                    </Row>
                                    <div className="body">
                                        <Row>
                                            <Col xs="12" md="4">
                                                <Form.Group>
                                                    <Form.Label className="font-weight-bold-600 text-secondary">Prioridad <span className="text-danger">*</span></Form.Label>
                                                    <Field 
                                                        type="text"
                                                        className={`form-control input-form ${errors.priority && 'error'}`}
                                                        name="priority"
                                                    />
                                                    { errors.priority && <div className="invalid-feedback d-block">{errors.priority}</div> }
                                                </Form.Group>
                                            </Col>
                                            <Col xs="12" md="8">
                                                <Form.Group>
                                                    <Form.Label className="font-weight-bold-600 text-secondary">Nombre <span className="text-danger">*</span></Form.Label>
                                                    <Field 
                                                        type="text"
                                                        className={`form-control input-form ${errors.name && 'error'}`}
                                                        name="name"
                                                    />
                                                    { errors.name && <div className="invalid-feedback d-block">{errors.name}</div> }
                                                </Form.Group>
                                            </Col>
                                            <Col xs="12" md="12">
                                                <Button type="submit" variant="link" className='btn-add float-right'>
                                                    <AiFillSave className="icon-save"/>
                                                </Button>{''}
                                            </Col>
                                        </Row>
                                    </div>   
                                </Card.Body>
                            </Card>
                        </Form>
                    )}</Formik>
                </Col>
            </Row>
        </>
    )

}

export default AddProveedores